import Link from "next/link";
import { useRouter } from "next/router";

import { FeedIcon } from "shared/providers/Layout/components/NewTopBar/assets/FeedIcon";
import { FeedIconLightMode } from "shared/providers/Layout/components/NewTopBar/assets/FeedIconLightMode";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import { FeedButtonContainer } from "./styles";

export const FeedButton = () => {
  const { asPath } = useRouter();
  const currentPath = asPath.split("/")?.[1];
  const { scrollIsOnTop } = useTopbarContext();
  const pageHaveMedia = currentPath === "browse";
  const {
    state: { theme },
  } = useGlobalContext();
  const isLighMode = theme?.value === "light";

  const shouldUseLighModeIcon = isLighMode && pageHaveMedia && scrollIsOnTop;

  return (
    <Link href="/feed" className="feed" prefetch={false}>
      <FeedButtonContainer>
        {shouldUseLighModeIcon ? <FeedIconLightMode /> : <FeedIcon />}
      </FeedButtonContainer>
    </Link>
  );
};
